export const categories = [
  { slug: "fragrance", name: "香氛系列", icon: "ri-contrast-drop-2-line", description: "探索东方香调的魅力世界" },
  { slug: "skincare", name: "肌肤养护", icon: "ri-heart-pulse-line", description: "以香养肤，由内而外" },
  { slug: "gift", name: "限定礼盒", icon: "ri-gift-line", description: "精心甄选的香氛礼遇" },
  { slug: "articles", name: "香氛文章", icon: "ri-book-open-line", description: "深度解读香氛文化与生活" },
];

export const allProductsByCategory: Record<string, Array<{
  id: string;
  name: string;
  tag: string;
  description: string;
  image: string;
  price: string;
  volume: string;
}>> = {
  fragrance: [
    {
      id: "frag-1",
      name: "暗夜玫瑰",
      tag: "经典热卖",
      description: "大马士革玫瑰与乌木的交织，展现出深邃而迷人的东方花香调，如暗夜中绽放的神秘玫瑰，令人沉醉不已。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20dark%20rose%20perfume%20bottle%20with%20deep%20crimson%20and%20black%20aesthetic%20on%20silk%20fabric%20with%20warm%20golden%20accents%2C%20elegant%20product%20photography%20with%20soft%20dramatic%20lighting%2C%20oriental%20luxury%20brand%20aesthetic%2C%20dark%20rich%20background%20with%20subtle%20warm%20glow&width=800&height=1000&seq=fragrance-rose-noir-01&orientation=portrait",
      price: "¥680",
      volume: "50ml",
    },
    {
      id: "frag-2",
      name: "檀韵清音",
      tag: "新品上市",
      description: "以印度老山檀香为主调，辅以雪松与琥珀，营造出沉静悠远的东方木质调，仿佛置身古寺檀烟，心境澄明。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20sandalwood%20fragrance%20bottle%20with%20minimalist%20warm%20beige%20and%20cream%20tones%20on%20raw%20silk%20texture%2C%20zen%20aesthetic%20with%20natural%20wood%20elements%2C%20clean%20elegant%20product%20photography%2C%20soft%20natural%20light%2C%20peaceful%20composition&width=800&height=1000&seq=fragrance-sandalwood-02&orientation=portrait",
      price: "¥580",
      volume: "50ml",
    },
    {
      id: "frag-3",
      name: "桂月凝香",
      tag: "限定系列",
      description: "金秋桂花与白茶的诗意邂逅，清甜而不腻，温婉而悠长。如同中秋月下漫步桂花园，一呼一吸皆是温柔。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20osmanthus%20fragrance%20bottle%20with%20soft%20golden%20amber%20tones%20on%20cream%20silk%20fabric%2C%20elegant%20oriental%20aesthetic%20with%20subtle%20floral%20elements%2C%20warm%20autumn%20lighting%2C%20minimalist%20luxury%20product%20photography%2C%20gentle%20romantic%20atmosphere&width=800&height=1000&seq=fragrance-osmanthus-03&orientation=portrait",
      price: "¥780",
      volume: "50ml",
    },
    {
      id: "frag-4",
      name: "兰芷清芬",
      tag: "",
      description: "白兰花与白芷的纯净组合，带来如清晨露水般清澈的气息。淡雅而持久，适合日常穿戴，宛如一抹不经意的优雅。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20white%20floral%20fragrance%20bottle%20with%20pure%20clean%20aesthetic%20on%20soft%20cream%20linen%2C%20elegant%20minimalist%20product%20photography%20with%20morning%20light%2C%20fresh%20dewy%20atmosphere%2C%20white%20and%20green%20subtle%20accents%2C%20sophisticated%20composition&width=800&height=1000&seq=fragrance-magnolia-04&orientation=portrait",
      price: "¥480",
      volume: "50ml",
    },
  ],
  skincare: [
    {
      id: "skin-1",
      name: "沉香润体乳",
      tag: "明星产品",
      description: "蕴含珍贵沉香精华与乳木果油，深层滋养肌肤，令肌肤如丝缎般柔滑，散发淡淡沉木香气。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20body%20lotion%20bottle%20with%20warm%20cream%20and%20gold%20accents%20on%20natural%20linen%20texture%2C%20elegant%20skincare%20product%20photography%2C%20spa%20aesthetic%20with%20soft%20warm%20light%2C%20minimalist%20luxury%20composition%2C%20serene%20atmosphere&width=800&height=1000&seq=skincare-body-lotion-01&orientation=portrait",
      price: "¥360",
      volume: "200ml",
    },
    {
      id: "skin-2",
      name: "玫瑰精华油",
      tag: "口碑之选",
      description: "高纯度大马士革玫瑰精油，配合角鲨烷与维生素E，深层修护肌肤屏障，令肌肤饱满莹润，散发自然光泽。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20facial%20oil%20bottle%20with%20rose%20gold%20and%20blush%20pink%20tones%20on%20soft%20silk%2C%20elegant%20skincare%20product%20photography%2C%20warm%20feminine%20aesthetic%2C%20delicate%20natural%20light%2C%20romantic%20composition&width=800&height=1000&seq=skincare-rose-oil-02&orientation=portrait",
      price: "¥520",
      volume: "30ml",
    },
    {
      id: "skin-3",
      name: "檀香护手霜",
      tag: "",
      description: "以檀香精油为核心，融合蜂蜜与甘油，深层滋润双手，修护干燥粗糙，留下一抹温暖的木质余香。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20hand%20cream%20tube%20with%20warm%20cream%20and%20sandalwood%20aesthetic%20on%20natural%20textured%20surface%2C%20elegant%20minimalist%20product%20photography%2C%20soft%20golden%20lighting%2C%20cozy%20atmosphere%2C%20clean%20composition&width=800&height=1000&seq=skincare-hand-cream-03&orientation=portrait",
      price: "¥180",
      volume: "75ml",
    },
    {
      id: "skin-4",
      name: "桂香身体磨砂",
      tag: "限定系列",
      description: "天然桂花花瓣与细砂糖颗粒，温和去除老废角质，同时散发桂花清香，令沐浴时光成为感官享受。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20body%20scrub%20jar%20with%20golden%20amber%20and%20cream%20tones%20on%20marble%20surface%2C%20elegant%20spa%20product%20photography%2C%20warm%20natural%20light%2C%20osmanthus%20aesthetic%2C%20sophisticated%20minimalist%20composition&width=800&height=1000&seq=skincare-body-scrub-04&orientation=portrait",
      price: "¥320",
      volume: "250g",
    },
  ],
  gift: [
    {
      id: "gift-1",
      name: "初见·香氛体验礼盒",
      tag: "热销爆款",
      description: "内含暗夜玫瑰、檀韵清音、桂月凝香、兰芷清芬四款2ml体验装，一次邂逅四重东方香调的魅力。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20fragrance%20discovery%20gift%20set%20in%20elegant%20box%20with%20gold%20foil%20details%20on%20silk%20fabric%2C%20warm%20ambient%20lighting%2C%20product%20photography%2C%20minimalist%20luxury%20aesthetic%2C%20oriental%20gift%20presentation&width=800&height=1000&seq=gift-discovery-set-01&orientation=portrait",
      price: "¥298",
      volume: "4×2ml",
    },
    {
      id: "gift-2",
      name: "倾城·玫瑰香礼套装",
      tag: "限定礼盒",
      description: "暗夜玫瑰香氛50ml + 玫瑰精华油30ml，双倍玫瑰力量，献给最爱的人或最值得的自己。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20rose%20fragrance%20and%20skincare%20gift%20set%20in%20elegant%20rose%20gold%20packaging%20on%20soft%20pink%20silk%2C%20romantic%20product%20photography%2C%20warm%20feminine%20aesthetic%2C%20delicate%20lighting%2C%20premium%20gift%20presentation&width=800&height=1000&seq=gift-rose-set-02&orientation=portrait",
      price: "¥1,080",
      volume: "套装",
    },
    {
      id: "gift-3",
      name: "禅意·身心养护礼盒",
      tag: "",
      description: "檀韵清音香氛50ml + 沉香润体乳200ml + 檀香护手霜75ml，完整的檀木香养护仪式。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20sandalwood%20fragrance%20and%20body%20care%20gift%20set%20in%20minimalist%20wooden%20box%20on%20natural%20linen%2C%20zen%20spa%20aesthetic%2C%20warm%20natural%20lighting%2C%20calm%20product%20photography%2C%20premium%20gift%20presentation&width=800&height=1000&seq=gift-zen-set-03&orientation=portrait",
      price: "¥980",
      volume: "套装",
    },
  ],
};

export const articlesList = [
  {
    id: "art-1",
    title: "东方香氛的前世今生：从宫廷御香到现代调香艺术",
    excerpt: "追溯东方香氛千年历史，从汉代博山炉到唐宋熏香文化，看东方香道如何影响当代调香美学。",
    category: "香氛文化",
    date: "2025-12-15",
    readTime: "8 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20incense%20ceremony%20with%20bronze%20censer%20and%20rising%20smoke%2C%20warm%20ambient%20light%2C%20ancient%20aesthetic%20with%20silk%20and%20wood%20elements%2C%20editorial%20photography%20style%2C%20serene%20atmosphere%2C%20cultural%20heritage%20vibe&width=800&height=500&seq=article-incense-history-01&orientation=landscape",
  },
  {
    id: "art-2",
    title: "香氛与情绪：如何用香气调节你的身心状态",
    excerpt: "探索芳香疗法的科学原理，了解不同香调如何影响我们的情绪、记忆与身心状态，找到属于你的香氛密码。",
    category: "芳香生活",
    date: "2025-11-28",
    readTime: "6 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20aromatherapy%20scene%20with%20essential%20oils%20and%20dried%20flowers%20on%20wooden%20table%2C%20warm%20natural%20light%20from%20window%2C%20spa%20wellness%20aesthetic%2C%20calm%20and%20peaceful%20composition%2C%20editorial%20photography&width=800&height=500&seq=article-aromatherapy-02&orientation=landscape",
  },
  {
    id: "art-3",
    title: "秋冬香氛指南：温暖木质调与东方辛香调的搭配艺术",
    excerpt: "秋冬季节如何选择适合自己的温暖香氛？从木质调到辛香调，为你解析最适合寒冷季节的香氛搭配法则。",
    category: "穿搭指南",
    date: "2025-11-10",
    readTime: "5 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20autumn%20winter%20fragrance%20collection%20on%20wool%20scarf%20with%20warm%20candlelight%2C%20cozy%20luxury%20aesthetic%2C%20dark%20wood%20and%20amber%20tones%2C%20editorial%20product%20photography%2C%20intimate%20atmosphere&width=800&height=500&seq=article-winter-fragrance-03&orientation=landscape",
  },
  {
    id: "art-4",
    title: "香氛的层次之美：前调、中调与后调的奥秘",
    excerpt: "了解香氛金字塔结构，掌握前调、中调、后调的区别与作用，让你更懂香氛的层次变化与持香之道。",
    category: "香氛文化",
    date: "2025-10-20",
    readTime: "7 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20fragrance%20notes%20pyramid%20illustration%20with%20perfume%20bottles%20and%20natural%20ingredients%20on%20cream%20background%2C%20editorial%20style%2C%20warm%20soft%20lighting%2C%20educational%20aesthetic%2C%20sophisticated%20composition&width=800&height=500&seq=article-fragrance-notes-04&orientation=landscape",
  },
  {
    id: "art-5",
    title: "以香养肤：当东方香道遇见现代护肤科学",
    excerpt: "从沉香到玫瑰，探索天然香料在护肤中的神奇功效，了解媚肉之香如何将千年香道智慧融入肌肤养护。",
    category: "芳香生活",
    date: "2025-09-15",
    readTime: "5 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20natural%20skincare%20ingredients%20with%20essential%20oils%20and%20herbs%20on%20wooden%20surface%2C%20spa%20wellness%20aesthetic%2C%20warm%20natural%20lighting%2C%20editorial%20photography%2C%20clean%20organic%20composition&width=800&height=500&seq=article-skincare-fragrance-05&orientation=landscape",
  },
  {
    id: "art-6",
    title: "香氛送礼指南：不同场合如何挑选最合适的香氛礼物",
    excerpt: "生日、纪念日、节日......不同场合适合什么样的香氛礼物？为你梳理最全的香氛送礼攻略。",
    category: "穿搭指南",
    date: "2025-08-22",
    readTime: "4 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20gift%20boxes%20with%20ribbons%20and%20fragrance%20bottles%20on%20silk%20fabric%2C%20warm%20golden%20lighting%2C%20festive%20yet%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20sophisticated%20presentation&width=800&height=500&seq=article-gift-guide-06&orientation=landscape",
  },
];